import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const ResumeAtsPage = ({ setPage }) => {
  const [resume, setResume] = useState('');
  const [jd, setJd] = useState('');
  const [res, setRes] = useState(null);
  const [err, setErr] = useState('');

  const run = async () => {
    setErr(''); setRes(null);
    try {
      const r = await fetch(`${API_BASE}/api/resume/ats-check`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ resume_text: resume, jd_text: jd }),
      });
      const data = await r.json();
      if (!r.ok) throw new Error(data.error || 'Failed');
      setRes(data);
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={ui.container}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>Resume ATS Checker</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:12}}>
        <textarea value={resume} onChange={(e)=>setResume(e.target.value)} rows={14} placeholder='Paste resume text' style={ui.textarea} />
        <textarea value={jd} onChange={(e)=>setJd(e.target.value)} rows={14} placeholder='Paste job description' style={ui.textarea} />
      </div>
      <button onClick={run} style={{...ui.primaryBtn, marginTop:10}}>Run ATS Check</button>
      {err && <div style={ui.error}>{err}</div>}
      {res && <div style={{marginTop:10, color:'#cbd5e1'}}>Score: <b>{res.score}</b> / 100</div>}
    </div>
  </div></main>;
};

export default ResumeAtsPage;
